import { Directive, EventEmitter, inject, Input, Output } from '@angular/core';
import { SelectableField } from '@lx/quote-tool/lite/shared/types';
import { SidePanelService } from '@lx/quote-tool/lite/shared/services';
import { SelectorField } from './selector-field.directive';

/**
 * Abstract class to be extended by components that require a selector dialog.
 */
@Directive()
export abstract class DialogBasedSelector<T> extends SelectorField<T> {
  @Input() selectedValue: T | undefined;
  @Input() disabled: boolean | undefined;

  @Output() selectedValueChange = new EventEmitter<T>();

  openSelectorClickHandler = () => this.openSelectorComponent();

  dialogVisible = false;

  readonly emptySelectionMsg = $localize`Select`;

  private readonly sidePanelService = inject(SidePanelService);

  openSelectorComponent() {
    this.dialogVisible = true;
  }

  handleSelectedValue({ value, fromUser }: SelectableField<T>) {
    this.onSelectValue(value);
    this.selectedValueChange.emit(value);
    if (fromUser) {
      this.hideDialog();
    }
  }

  hideDialog() {
    this.markAsTouched();
    this.sidePanelService.hidePanel(() => (this.dialogVisible = false));
  }
}
